
import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import { compose } from "recompose"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps"

import axios from 'axios';



const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {			
			payee_list: [],
			category_details: [],
			loading: false,		
			student_list: [],
			selectedMarker: false,
			student_list: [],	
		}
		this.goBack = this.goBack.bind(this);
	}
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];

			  
				var app = {user_id : user_id,school_id:school_id}			
				getData('fees/map_student_details_list',app).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									student_list: result['data'],
								});
							}else{
								this.setState({
									student_list: [],
								});
							}
						}
					});	
			

	}
  }
    
    handleClick = (marker, event) => {
    // console.log({ marker })
    this.setState({ selectedMarker: marker })
  }
 
  handleChange = ({ fileList }) => this.setState({ fileList });
	
	goBack(){
		window.location.href = '/expenses/index';
	}
	
	render()

	{

	
const MapWithAMarker = compose(withScriptjs, withGoogleMap)(props => {
  const infoWindowContent = <div>Hi</div>
  return (
    <GoogleMap defaultZoom={8} defaultCenter={{ lat:19.0760, lng: 72.8777 }}>
      {props.markers.map(marker => {
        const onClick = props.onClick.bind(this, marker)
        return (
          <Marker
            key={marker.id}
            onClick={onClick}
            position={{ lat: marker.latitude, lng: marker.longitude }}>
            {props.selectedMarker === marker &&
              <InfoWindow>
                <div>
                  {marker.name}
                </div>
              </InfoWindow>}
            }
          </Marker>
        )
      })}
    </GoogleMap>
  )
})
				
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Heat Map</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Heat Map</li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			 <div class="col s12 m12 ex-padd">
            <div class="container view-Profile child-profile">
			   <div class="col s12 m12 mb-20 iq-card card card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">

					    <MapWithAMarker
						selectedMarker={this.state.selectedMarker}
						markers={this.state.student_list}
						onClick={this.handleClick}						googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAs0BIt4S9mkyigRPZMdgtKByDb0bd424A&v=3.exp&libraries=geometry,drawing,places"
						loadingElement={<div style={{ height: `100%` }} />}
						containerElement={<div style={{ height: `400px` }} />}
						mapElement={<div style={{ height: `100%` }} />}
					  />
									
								  

                  </section>
               </div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
